export * from './simple-callout-color.config';
export * from './simple-callout.component';
export * from './simple-callout.extension';
